import React from "react";
import PropTypes from "prop-types";
import Filter from "../../../../../models/Filter";

function SelectFilter({ handleChange, filter, handleHighlight }) {
  const { id, options, value } = filter;
  const firstVal = options[0]?.key;
  const val = value === undefined ? firstVal : value;
  return (
    <div
      onMouseMove={() => handleHighlight(null, null)}
      className="tw-pt-2 tw-w-full tw-mt-2 tw-border-t tw-border-blueGray-400 tw-border-opacity-30"
    >
      <div className="color-1 tw-flex tw-justify-items-center tw-items-center">
        <div className="tw-opacity-80 tw-flex-grow tw-min-w-28">
          {filter.label}
        </div>

        <div className="tw-flex-grow">
          <select
            value={String(val)}
            onChange={(e) => handleChange({ ids: [id], value: e.target.value })}
            className="tw-w-full tw-p-1 color-1 bg-1 tw-mr-2"
          >
            {options.map((x) => (
              <option key={x.key} value={String(x.key)}>
                {x.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

SelectFilter.propTypes = {
  filter: PropTypes.instanceOf(Filter).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleHighlight: PropTypes.func.isRequired,
};

export default SelectFilter;
